/* COSYFUR Atelier — interactions */
(function () {
  'use strict';

  /* Header : transparent → solide au scroll */
  var header = document.getElementById('siteHeader');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-solid', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Menu mobile */
  var burger = document.getElementById('burger');
  var mobileMenu = document.getElementById('mobileMenu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Galerie produit : vignettes */
  var mainImg = document.getElementById('galleryMain');
  if (mainImg) {
    document.querySelectorAll('.gallery-thumbs button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        mainImg.src = btn.getAttribute('data-src');
        document.querySelectorAll('.gallery-thumbs button').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
      });
    });
  }

  /* Variantes : swatch → input id + image + URL */
  var variantInput = document.getElementById('variantId');
  if (variantInput) {
    document.querySelectorAll('.swatch input').forEach(function (radio) {
      radio.addEventListener('change', function () {
        variantInput.value = radio.value;
        var img = radio.getAttribute('data-image');
        if (img && mainImg) {
          mainImg.src = img;
          document.querySelectorAll('.gallery-thumbs button').forEach(function (b) {
            b.classList.toggle('is-active', b.getAttribute('data-src') === img);
          });
        }
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', radio.value);
          history.replaceState(null, '', url.toString());
        }
      });
    });
  }

  /* Quantité +/- */
  document.querySelectorAll('.qty').forEach(function (q) {
    var input = q.querySelector('input');
    var btns = q.querySelectorAll('button');
    if (!input || btns.length < 2) return;
    btns[0].addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    btns[1].addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });
})();
